import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, euro } from "@/lib/api";

const Q = [
  { key: "result", label: "Qual è il risultato che desideri?", opts: [["naturale", "Naturale e curato"], ["elegante", "Elegante e strutturato"], ["ricostruzione", "Ricostruzione"], ["creativo", "Creativo / nail art"]] },
  { key: "current", label: "Cosa hai attualmente sulle unghie?", opts: [["niente", "Niente"], ["semipermanente", "Semipermanente"], ["gel", "Gel / ricostruzione"], ["altro", "Prodotto di un altro salone"]] },
  { key: "removal", label: "È necessaria la rimozione?", opts: [[true, "Sì"], [false, "No"]] },
  { key: "style", label: "Che stile preferisci?", opts: [["naturale", "Naturale"], ["elegante", "Elegante"], ["creativo", "Creativo"], ["statement", "Statement"]] },
  { key: "broken_nails", label: "Quante unghie rotte hai?", opts: [[0, "Nessuna"], [1, "Una"], [2, "Due o più"]] },
];

export default function KimaMatch() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const nav = useNavigate();

  const pick = async (key, val) => {
    const next = { ...answers, [key]: val };
    setAnswers(next);
    if (step < Q.length - 1) setStep(step + 1);
    else {
      const { data } = await api.post("/kima-match", next);
      setResult(data);
    }
  };

  if (result) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-20 animate-fade-up">
        <span className="kima-overline text-burgundy">Il tuo risultato</span>
        <h1 className="font-serif text-5xl text-espresso mt-3 mb-8">Consiglio KIMA</h1>
        <div className="border border-espresso/10 bg-offwhite rounded-sm p-8">
          <h2 className="font-serif text-3xl text-espresso mb-2">{result.service.name}</h2>
          <p className="text-espresso/60 mb-6">{result.service.description}</p>
          <div className="grid grid-cols-2 gap-4 text-sm mb-6">
            <div className="border border-espresso/10 p-4 rounded-sm"><div className="kima-overline text-taupe">Durata stimata</div><div className="text-espresso text-lg mt-1">{result.estimated_duration} min</div></div>
            <div className="border border-espresso/10 p-4 rounded-sm"><div className="kima-overline text-taupe">Fascia di prezzo</div><div className="text-espresso text-lg mt-1">{euro(result.price_range.min)}–{euro(result.price_range.max)}</div></div>
            <div className="border border-espresso/10 p-4 rounded-sm"><div className="kima-overline text-taupe">Livello artista</div><div className="text-espresso text-lg mt-1">{result.skill_level}</div></div>
            <div className="border border-espresso/10 p-4 rounded-sm"><div className="kima-overline text-taupe">Extra consigliati</div><div className="text-espresso mt-1">{result.addons.length ? result.addons.map(a => a.name).join(", ") : "Nessuno"}</div></div>
          </div>
          <p className="text-xs text-espresso/50 italic mb-6">{result.note}</p>
          <button onClick={() => nav(`/prenota?service=${result.service.id}&match=1`)} data-testid="match-book" className="w-full bg-espresso text-ivory py-4 rounded-sm hover:bg-burgundy transition-colors">Prenota questo servizio</button>
        </div>
      </div>
    );
  }

  const q = Q[step];
  return (
    <div className="max-w-2xl mx-auto px-6 py-20">
      <div className="flex gap-2 mb-10">{Q.map((_, i) => (<div key={i} className={`h-1 flex-1 rounded-full transition-colors ${i <= step ? "bg-burgundy" : "bg-softgrey"}`} />))}</div>
      <span className="kima-overline text-burgundy">Domanda {step + 1} / {Q.length}</span>
      <h1 className="font-serif text-4xl text-espresso mt-3 mb-10">{q.label}</h1>
      <div className="grid gap-3">
        {q.opts.map(([val, lbl]) => (
          <button key={String(val)} onClick={() => pick(q.key, val)} data-testid={`match-opt-${q.key}-${val}`} className="text-left border border-espresso/15 bg-offwhite px-6 py-5 rounded-sm hover:border-burgundy hover:bg-espresso hover:text-ivory transition-colors">{lbl}</button>
        ))}
      </div>
      {step > 0 && <button onClick={() => setStep(step - 1)} className="mt-8 text-sm text-taupe hover:text-espresso transition-colors">← Indietro</button>}
    </div>
  );
}
